import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomObjectIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CustomObject",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.21 15.8c-.01.42-.14.82-.37 1.17-.16.25-.35.48-.58.67v4.67l-6.62 3.85v-7.69l1.03-.6c0-.22.03-.44.09-.65v-.21c.1-.61.27-1.2.48-1.78l-2.6 1.53-6.65-3.85 6.65-3.85 5.64 3.25c.06-.27.19-.51.39-.7.2-.22.47-.37.76-.43h.05l-.96-.96-5.39-3.17c-.15-.08-.32-.13-.5-.13s-.35.05-.5.14l-8.65 4.98c-.3.18-.48.51-.48.86v9.96c0 .35.18.68.49.86l8.66 4.97c.3.17.66.17.96 0l8.66-4.97c.31-.18.5-.51.5-.87v-7.44c-.27.23-.61.36-.96.36l-.1.04Zm-9.56 10.3-6.64-3.85v-7.69l6.63 3.85v7.69Zm5.84-12.22c-1.41.79-1.65 3-1.78 3.56s-.08.73.16.91c.5.32.75-.07 1.23-.53s2.05 0 2.89-1.39-1.09-3.38-2.5-2.56Zm1.88-1.57.03-.03c.21-.21.54-.21.75 0l1.59 1.58c.21.21.21.54 0 .75l-.03.03c-.21.21-.54.21-.75 0l-1.59-1.58a.525.525 0 0 1 0-.75M27 13.36c-.18 0-.37.02-.55.06l-2.26-2.26 5.38-5.37c.29-.28.45-.67.43-1.08 0-.84-.68-1.53-1.53-1.53-.41 0-.79.16-1.08.45l-5.4 5.35-5.06-5.09c-.28-.29-.67-.45-1.08-.45-.84-.02-1.54.66-1.56 1.5v.03c0 .4.16.79.44 1.08l5.09 5.1-.28.28 2.13 2.21.32-.32 2.26 2.25c-.04.17-.06.35-.06.53 0 1.52 1.23 2.75 2.75 2.75q.495 0 .96-.18l-1.11-1.15a1.18 1.18 0 0 1-.36-.85c0-.32.13-.64.36-.87.19-.19.45-.3.72-.3s.53.1.71.3l1.33 1.29c.11-.31.17-.63.17-.96a2.75 2.75 0 0 0-2.73-2.77ZM15.61 5.1a.39.39 0 1 1 .39-.39c0 .21-.18.38-.39.38Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23.57 29.29h-9.14c-.63 0-1.14-.51-1.14-1.14V16.72c0-.63.51-1.14 1.14-1.14h9.14c1.89 0 3.43 1.54 3.43 3.43v6.86c0 1.89-1.54 3.43-3.43 3.43Zm-8-2.29h8c.63 0 1.14-.51 1.14-1.14V19c0-.63-.51-1.14-1.14-1.14h-8z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.43 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43v-9.14c0-.63.51-1.14 1.14-1.14h11.43c.63 0 1.14.51 1.14 1.14v11.43c0 .63-.51 1.14-1.14 1.14M4.14 17.86v8c0 .63.51 1.14 1.14 1.14h8v-9.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.43 17.86H3c-.63 0-1.14-.51-1.14-1.14V7.57c0-1.89 1.54-3.43 3.43-3.43h6.86c1.89 0 3.43 1.54 3.43 3.43v9.14c0 .63-.51 1.14-1.14 1.14ZM4.14 15.57h9.14v-8c0-.63-.51-1.14-1.14-1.14H5.28c-.63 0-1.14.51-1.14 1.14zM23.57 13.29c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v9.14c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 8.71H19a1.14 1.14 0 1 1 0-2.28h9.14a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
CustomObjectIcon.displayName = 'CustomObjectIcon';